export default {
  title: 'Brand sync — Brands',
  subtitle:
    'Overview of all restaurants in the group and their synced features. Only the account admin can make changes.',
  alert: {
    message: 'Admin-only access',
    description:
      'Changes to the master menu, pricing, and offers can only be made by the account admin. All locations automatically receive updates.',
  },
  locations: {
    title: 'Locations',
    description: 'All restaurants in the group sharing the master menu and settings',
    locations_zero: '0 locations',
    locations_one: '1 location',
    locations_other: '{{count}} locations',
    synced: 'Synced',
  },
  features: {
    title: 'Synced Features',
    description: 'These features are controlled by the master settings',
    menus: {
      title: 'Master Menu',
      desription: 'Menu items, categories, and descriptions are synced across all locations',
    },
    smart_pricing: {
      title: 'Smart Pricing',
      desription: 'Pricing rules and adjustments are synced across all locations',
    },
    offers: {
      title: 'Offers & Promotions',
      desription: 'Active offers, discounts, and promotions are synced across all locations',
    },
  },
};
